document.addEventListener('DOMContentLoaded', () => {
  const sizeFinders = document.querySelectorAll('[data-size-finder]');

  sizeFinders.forEach((sizeFinder) => {
    const productHandle = sizeFinder.dataset.productHandle;
    const productTitle = sizeFinder.dataset.productTitle;

    // --------------------------------------------------
    // SIZE CHARTS
    // Garment measurements in inches
    // --------------------------------------------------

    const sizeProfiles = {
      racerback: {
        XS: { chest: 32, hips: 36 },
        S: { chest: 34, hips: 38 },
        M: { chest: 36, hips: 38 },
        L: { chest: 38, hips: 40 },
        XL: { chest: 44, hips: 46 },
        '2XL': { chest: 46, hips: 48 },
        '3XL': { chest: 50, hips: 51 }
      },

      longSleeve: {
        XS: { chest: 32, hips: 34 },
        S: { chest: 34, hips: 38 },
        M: { chest: 38, hips: 41 },
        L: { chest: 40, hips: 44 },
        XL: { chest: 44, hips: 51 },
        '2XL': { chest: 46, hips: 50 },
        '3XL': { chest: 50, hips: 52 }
      },

      organicTee: {
        XS: { chest: 31, hips: 38 },
        S: { chest: 34, hips: 38 },
        M: { chest: 38, hips: 42 },
        L: { chest: 44, hips: 46 },
        XL: { chest: 46, hips: 50 },
        '2XL': { chest: 47, hips: 52 },
        '3XL': { chest: 50, hips: 58 }
      },

      relaxedTank: {
        XS: { chest: 32, hips: 36 },
        S: { chest: 36, hips: 38 },
        M: { chest: 38, hips: 40 },
        L: { chest: 40, hips: 43 },
        XL: { chest: 42, hips: 46 },
        '2XL': { chest: 46, hips: 50 },
        '3XL': { chest: 50, hips: 54 }
      }
    };

    const sizeOrder = ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL'];

    // --------------------------------------------------
    // PRODUCT PROFILE
    // --------------------------------------------------

    function getProductProfile() {
      const text = `${productHandle || ''} ${productTitle || ''} ${document.title || ''}`.toLowerCase();
      console.log('SIZE FINDER PRODUCT:', {
  productHandle,
  productTitle,
  documentTitle: document.title,
  text
});


      if (text.includes('racerback')) {
        return 'racerback';
      }

      if (text.includes('long-sleeve') || text.includes('long sleeve')) {
        return 'longSleeve';
      }

      if (text.includes('relaxed-tank') || text.includes('relaxed tank')) {
        return 'relaxedTank';
      }

      if (
        text.includes('organic') &&
        (
          text.includes('t-shirt') ||
          text.includes('tshirt') ||
          text.includes('tee')
        )
      ) {
        return 'organicTee';
      }

      return null;
    }

    const productProfile = getProductProfile();

    // --------------------------------------------------
    // ELEMENTS
    // --------------------------------------------------

    const openButton = sizeFinder.querySelector('[data-size-finder-open]');
    const overlay = sizeFinder.querySelector('[data-size-finder-overlay]');
    const closeButton = sizeFinder.querySelector('[data-size-finder-close]');
    const startButton = sizeFinder.querySelector('[data-size-finder-start]');

    const intro = sizeFinder.querySelector('.kc-size-finder__content');

    const question1 = sizeFinder.querySelector(
      '[data-size-finder-question-1]'
    );

    const question2 = sizeFinder.querySelector(
      '[data-size-finder-question-2]'
    );

    const question3 = sizeFinder.querySelector(
      '[data-size-finder-question-3]'
    );

    const measurementsScreen = sizeFinder.querySelector(
      '[data-size-finder-measurements]'
    );

    const resultScreen = sizeFinder.querySelector(
      '[data-size-finder-result]'
    );

    const sizeButtons = question1?.querySelectorAll('[data-size]') || [];
    const fitButtons = question2?.querySelectorAll('[data-fit]') || [];

    const measurementButtons =
      question3?.querySelectorAll('[data-measurements]') || [];

    const recommendedSizeDisplay = sizeFinder.querySelector(
      '[data-recommended-size]'
    );

    const selectSizeButton = sizeFinder.querySelector(
      '[data-size-finder-select]'
    );
    const reviewSizeChartButton = sizeFinder.querySelector (`[data-size-finder-chart]`)
    const helpButton = sizeFinder.querySelector('[data-size-finder-help]');
const helpForm = sizeFinder.querySelector('[data-size-finder-help-form]');
const helpEmailInput = sizeFinder.querySelector('[data-size-finder-email]');
const helpCommentInput = sizeFinder.querySelector('[data-size-finder-comment]');
const helpSubmitButton = sizeFinder.querySelector('[data-size-finder-help-submit]');

    const measurementsContinue = sizeFinder.querySelector(
      '[data-measurements-continue]'
    );

    const chestInput = sizeFinder.querySelector(
      '[data-measurement-chest]'
    );

    const hipsInput = sizeFinder.querySelector(
      '[data-measurement-hips]'
    );

    if (!openButton || !overlay || !closeButton) return;

    // --------------------------------------------------
    // ANSWERS
    // --------------------------------------------------

    const answers = {
      usualSize: null,
      preferredFit: null,
      chest: null,
      hips: null
    };

    // --------------------------------------------------
    // HELPERS
    // --------------------------------------------------

    function adjustSize(size, direction) {
      const index = sizeOrder.indexOf(size);

      if (index === -1) return size;

      const newIndex = Math.max(
        0,
        Math.min(sizeOrder.length - 1, index + direction)
      );

      return sizeOrder[newIndex];
    }

    function showResult(recommendedSize) {
      recommendedSizeDisplay.textContent = recommendedSize;
      selectSizeButton.textContent = `SELECT SIZE ${recommendedSize}`;

      measurementsScreen.hidden = true;
      resultScreen.hidden = false;
    }

    // --------------------------------------------------
    // WITHOUT MEASUREMENTS
    // --------------------------------------------------

    function recommendWithoutMeasurements() {
      let recommendedSize = answers.usualSize;

      if (answers.preferredFit === 'Fitted') {
        recommendedSize = adjustSize(recommendedSize, -1);
      }

      if (answers.preferredFit === 'Relaxed') {
        recommendedSize = adjustSize(recommendedSize, 1);
      }

      return recommendedSize;
    }

    // --------------------------------------------------
    // WITH MEASUREMENTS
    // --------------------------------------------------

    function recommendWithMeasurements() {
        const currentProductProfile = getProductProfile ();
     if (!currentProductProfile) {
  console.error('Size Finder: Product profile not recognized', {
    productHandle,
    productTitle
  });

  return null;
}

      const profile = sizeProfiles[productProfile];

      if (!profile) {
        return answers.usualSize;
      }

      const easeByFit = {
        Fitted: 0,
        Regular: 0,
        Relaxed: 1.5,
      };

      const ease = easeByFit[answers.preferredFit] ?? 3;

      const targetChest =
        answers.chest !== null
          ? answers.chest + ease
          : null;

      const targetHips =
        answers.hips !== null
          ? answers.hips + ease
          : null;

      // Find the smallest size that accommodates
      // BOTH chest and hips.
      for (const size of sizeOrder) {
        const measurements = profile[size];

        if (!measurements) continue;

        const chestFits =
          targetChest === null ||
          measurements.chest >= targetChest;

        const hipsFit =
          targetHips === null ||
          measurements.hips >= targetHips;

        if (chestFits && hipsFit) {
          return size;
        }
      }

      // Measurements exceed the chart.
      // Recommend the largest available chart size.
      return sizeOrder[sizeOrder.length - 1];
    }

    // --------------------------------------------------
    // OPEN / START
    // --------------------------------------------------

    openButton.addEventListener('click', () => {
      overlay.hidden = false;
    });

    startButton.addEventListener('click', () => {
      intro.hidden = true;
      question1.hidden = false;
    });

    // --------------------------------------------------
    // QUESTION 1 - USUAL SIZE
    // --------------------------------------------------

    sizeButtons.forEach((button) => {
      button.addEventListener('click', () => {
        answers.usualSize = button.dataset.size;

        question1.hidden = true;
        question2.hidden = false;
      });
    });

    // --------------------------------------------------
    // QUESTION 2 - PREFERRED FIT
    // --------------------------------------------------

    fitButtons.forEach((button) => {
      button.addEventListener('click', () => {
        answers.preferredFit = button.dataset.fit;

        question2.hidden = true;
        question3.hidden = false;
      });
    });

    // --------------------------------------------------
    // QUESTION 3 - MEASUREMENTS?
    // --------------------------------------------------

    measurementButtons.forEach((button) => {
      button.addEventListener('click', () => {
        question3.hidden = true;

        if (button.dataset.measurements === 'yes') {
          measurementsScreen.hidden = false;
          return;
        }

        if (button.dataset.measurements === 'no') {
          const recommendedSize =
            recommendWithoutMeasurements();

          showResult(recommendedSize);
        }
      });
    });

    // --------------------------------------------------
    // MEASUREMENTS
    // --------------------------------------------------

    measurementsContinue.addEventListener('click', () => {
      answers.chest =
        parseFloat(chestInput.value) || null;

      answers.hips =
        parseFloat(hipsInput.value) || null;

      const recommendedSize =
        recommendWithMeasurements();

      showResult(recommendedSize);
    });

    // Prevent Shopify variant picker from reacting
    // while typing measurements.

    overlay.addEventListener('input', (event) => {
      event.stopPropagation();
    });

    overlay.addEventListener('change', (event) => {
      event.stopPropagation();
    });

    // --------------------------------------------------
    // SELECT RECOMMENDED SHOPIFY SIZE
    // --------------------------------------------------

    if (selectSizeButton) {
      selectSizeButton.addEventListener('click', () => {
        const recommendedSize =
          recommendedSizeDisplay.textContent.trim();

        const variantPicker =
          sizeFinder.closest('variant-picker');

        if (!variantPicker) return;

        const sizeInput = variantPicker.querySelector(
          `input[data-option-name="Size"][value="${recommendedSize}"]`
        );

        if (sizeInput) {
          sizeInput.checked = true;

          sizeInput.dispatchEvent(
            new Event('change', { bubbles: true })
          );

          overlay.hidden = true;
        }
      });
    }
    let smartSizeButtonOpenedFromQuiz = false
    if (reviewSizeChartButton) {
  reviewSizeChartButton.addEventListener('click', () => {
    const smartSizeButton = document.querySelector('.smartsize-trigger');

    if (smartSizeButton) {
      smartSizeButtonOpenedFromQuiz = true
      overlay.hidden = true;
      smartSizeButton.click();
    }
  });
}
document.addEventListener('click', (event) => {
  const smartSizeCloseButton = event.target.closest('.smartsize-close-button');

 if (smartSizeCloseButton && smartSizeButtonOpenedFromQuiz) {
  smartSizeButtonOpenedFromQuiz = false;

  setTimeout(() => {
    overlay.hidden = false;
    resultScreen.hidden = false;
  }, 100);
}
});
if (helpButton) {
  helpButton.addEventListener('click', () => {
    const params = new URLSearchParams({
      product: productTitle || document.title,
      productUrl: window.location.pathname,
      recommended: recommendedSizeDisplay.textContent.trim(),
      usual: answers.usualSize || '',
      fit: answers.preferredFit || '',
      chest: answers.chest ?? '',
      hips: answers.hips ?? ''
    });

    window.open(
      `/pages/fit-help?${params.toString()}`,
      '_blank',
      'noopener'
    );
  });
}

if (helpSubmitButton) {
  helpSubmitButton.addEventListener('click', () => {
    const email = helpEmailInput?.value.trim();
    const comment = helpCommentInput?.value.trim();

    const fitRequest = {
      email: email,
      comment: comment,
      product: productTitle || document.title,
      usualSize: answers.usualSize,
      preferredFit: answers.preferredFit,
      chest: answers.chest,
      hips: answers.hips,
      recommendedSize: recommendedSizeDisplay.textContent.trim()
    };

    console.log('FIT REQUEST:', fitRequest);
    console.log('CHEST:', fitRequest.chest);
console.log('HIPS:', fitRequest.hips);
console.log('RECOMMENDED:', fitRequest.recommendedSize);
if (!email) {
  alert('Please enter your email.');
  return;
}

const contactForm = document.createElement('form');
contactForm.method = 'POST';
contactForm.action = '/contact#contact_form';
contactForm.style.display = 'none';
contactForm.setAttribute('data-shopify-captcha', 'true');

const fields = {
  form_type: 'contact',
  utf8: '✓',
  'contact[email]': fitRequest.email,
  'contact[body]': fitRequest.comment || 'Size Finder fit request',
  'contact[Product]': fitRequest.product,
  'contact[Usual Size]': fitRequest.usualSize || 'Not provided',
  'contact[Preferred Fit]': fitRequest.preferredFit || 'Not provided',
  'contact[Chest]': fitRequest.chest ?? 'Not provided',
  'contact[Hips]': fitRequest.hips ?? 'Not provided',
  'contact[Recommended Size]': fitRequest.recommendedSize
};

Object.entries(fields).forEach(([name, value]) => {
  const input = document.createElement('input');
  input.type = 'hidden';
  input.name = name;
  input.value = value;
  contactForm.appendChild(input);
});

document.body.appendChild(contactForm);

if (window.Shopify?.captcha?.protect) {
  window.Shopify.captcha.protect(contactForm, () => {
    contactForm.submit();
  });
} else {
  contactForm.submit();
}

  });
}

    // --------------------------------------------------
    // CLOSE
    // --------------------------------------------------

    closeButton.addEventListener('click', () => {
      overlay.hidden = true;
    });

    overlay.addEventListener('click', (event) => {
      if (event.target === overlay) {
        overlay.hidden = true;
      }
    });
  });
});
